import React, { useState } from 'react';
import { HelpCircle, ChevronDown, ChevronUp, Package, Truck, CreditCard, ShoppingBag, RotateCcw, Phone, Search } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const FAQPage = () => {
    const [openItems, setOpenItems] = useState({});
    const [searchQuery, setSearchQuery] = useState('');
    const [activeCategory, setActiveCategory] = useState('all');

    const toggleItem = (id) => {
        setOpenItems(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const categories = [
        { id: 'all', name: 'Всички', icon: HelpCircle },
        { id: 'orders', name: 'Поръчки', icon: ShoppingBag },
        { id: 'delivery', name: 'Доставка', icon: Truck },
        { id: 'payment', name: 'Плащане', icon: CreditCard },
        { id: 'products', name: 'Продукти', icon: Package },
        { id: 'returns', name: 'Връщане', icon: RotateCcw },
    ];

    const faqs = [
        // Orders
        {
            id: 1,
            category: 'orders',
            q: 'Как да направя поръчка?',
            a: 'Изберете желаните продукти и ги добавете в количката. След това отидете в количката, проверете избраните продукти и натиснете "Продължи към плащане". Попълнете адреса за доставка, изберете начин на плащане и потвърдете поръчката.'
        },
        {
            id: 2,
            category: 'orders',
            q: 'Как да проследя поръчката си?',
            a: 'След изпращане на поръчката ще получите SMS и имейл с номер за проследяване. Можете да следите пратката на сайта на Еконт (econt.com) или като влезете в профила си на нашия сайт.'
        },
        {
            id: 3,
            category: 'orders',
            q: 'Мога ли да променя или откажа поръчка?',
            a: 'Да, можете да промените или откажете поръчката си, ако тя все още не е изпратена. Свържете се с нас възможно най-скоро на телефон 0899 97 2727 или по имейл.'
        },
        {
            id: 4,
            category: 'orders',
            q: 'Какво да правя, ако получа грешен продукт?',
            a: 'Свържете се с нас незабавно на 0899 97 2727. Ще организираме безплатно връщане на грешния продукт и изпращане на правилния. Извиняваме се за неудобството!'
        },
        // Delivery
        {
            id: 5,
            category: 'delivery',
            q: 'Колко струва доставката?',
            a: 'За гр. София: БЕЗПЛАТНА доставка с наш шофьор (доставяме лично, без Еконт). За останалата част на България: доставка с Еконт - до офис от 2.30 €, до адрес от 3.32 € (платена от клиента).'
        },
        {
            id: 6,
            category: 'delivery',
            q: 'Колко време отнема доставката?',
            a: 'Стандартната доставка е 2-3 работни дни за цяла България. Поръчки, направени до 14:00ч в работен ден, се обработват и изпращат в същия ден.'
        },
        {
            id: 7,
            category: 'delivery',
            q: 'Доставяте ли в чужбина?',
            a: 'В момента доставяме само на територията на България. Планираме да разширим доставката до други страни в близко бъдеще.'
        },
        {
            id: 8,
            category: 'delivery',
            q: 'Какво става, ако не съм на адреса при доставка?',
            a: 'Курierът ще се опита да се свърже с вас по телефона. Ако не успее, пратката ще бъде оставена в най-близкия офис на Еконт, където можете да я вземете в удобно за вас време (до 7 дни безплатно съхранение).'
        },
        // Payment
        {
            id: 9,
            category: 'payment',
            q: 'Какви методи на плащане приемате?',
            a: 'Приемаме: Наложен платеж (плащане в брой при получаване), Плащане с карта онлайн (Visa, Mastercard, American Express) и Банков превод.'
        },
        {
            id: 10,
            category: 'payment',
            q: 'Безопасно ли е да плащам онлайн?',
            a: 'Да, използваме Stripe - една от най-сигурните платежни системи в света. Вашите данни са защитени с 256-bit SSL криптиране и ние никога не съхраняваме информация за картата ви.'
        },
        {
            id: 11,
            category: 'payment',
            q: 'Кога се таксува картата ми?',
            a: 'Картата ви се таксува веднага след потвърждаване на поръчката. При отказ на поръчка преди изпращане, сумата се възстановява в рамките на 5-10 работни дни.'
        },
        // Products
        {
            id: 12,
            category: 'products',
            q: 'Откъде са вашите продукти?',
            a: 'Продуктите ни са директен внос от Турция и Европа. Работим само с доказани производители и гарантираме автентичност и качество на всеки продукт.'
        },
        {
            id: 13,
            category: 'products',
            q: 'Как съхранявате продуктите?',
            a: 'Всички продукти се съхраняват при оптимални условия - правилна температура и влажност. Сладкарските изделия се пазят в хладно и сухо място, за да запазят своята свежест.'
        },
        {
            id: 14,
            category: 'products',
            q: 'Какъв е срокът на годност?',
            a: 'Срокът на годност варира според продукта. Локумът и баклавата обикновено са с минимум 3-6 месеца срок. Точният срок е посочен на опаковката на всеки продукт.'
        },
        {
            id: 15,
            category: 'products',
            q: 'Имате ли продукти без захар или глутен?',
            a: 'Да, предлагаме селекция от продукти без захар и без глутен. Използвайте филтрите на страницата с продукти или се свържете с нас за повече информация.'
        },
        // Returns
        {
            id: 16,
            category: 'returns',
            q: 'Мога ли да върна продукт?',
            a: 'Да, имате право да върнете продукт в 14-дневен срок от получаването, ако е в оригинална опаковка и не е отварян. За хранителни продукти важат специфични условия - свържете се с нас за детайли.'
        },
        {
            id: 17,
            category: 'returns',
            q: 'Как да върна продукт?',
            a: 'Свържете се с нас на 0899 97 2727 или по имейл. Ще ви изпратим етикет за безплатно връщане с Еконт. След получаване и проверка на продукта, сумата ще бъде възстановена в рамките на 5-10 работни дни.'
        },
        {
            id: 18,
            category: 'returns',
            q: 'Какво да правя, ако продуктът е повреден?',
            a: 'Ако получите повреден продукт, незабавно направете снимки и се свържете с нас. Ще организираме безплатна замяна или пълно възстановяване на сумата.'
        },
    ];

    const filteredFaqs = faqs.filter(faq => {
        const matchesCategory = activeCategory === 'all' || faq.category === activeCategory;
        const matchesSearch = faq.q.toLowerCase().includes(searchQuery.toLowerCase()) || 
                             faq.a.toLowerCase().includes(searchQuery.toLowerCase());
        return matchesCategory && matchesSearch;
    });

    return (
        <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white">
            {/* Hero */}
            <section className="relative py-24 bg-gradient-to-r from-amber-600 via-orange-500 to-amber-600 text-white overflow-hidden">
                <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=1200')] bg-cover bg-center opacity-20" />
                <div className="absolute inset-0 bg-gradient-to-r from-amber-600/90 via-orange-500/90 to-amber-600/90" />
                <div className="container-main relative z-10">
                    <div className="max-w-3xl">
                        <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium mb-6">
                            <HelpCircle className="w-4 h-4" /> Помощен център
                        </span>
                        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold mb-6">Често задавани въпроси</h1>
                        <p className="text-white/90 text-lg md:text-xl leading-relaxed">
                            Намерете отговори на най-честите въпроси за поръчки, доставка и продукти
                        </p>
                    </div>
                </div>
            </section>

            {/* Search */}
            <section className="py-8 -mt-8 relative z-10">
                <div className="container-main">
                    <div className="max-w-2xl mx-auto">
                        <div className="relative">
                            <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-amber-400" />
                            <Input
                                type="text"
                                placeholder="Търсете въпрос..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="w-full pl-12 py-6 text-lg bg-white border-amber-200 rounded-2xl shadow-xl focus:border-amber-400"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Categories */}
            <section className="py-8">
                <div className="container-main">
                    <div className="flex flex-wrap justify-center gap-3">
                        {categories.map((cat) => (
                            <button
                                key={cat.id}
                                onClick={() => setActiveCategory(cat.id)}
                                className={`flex items-center gap-2 px-5 py-3 rounded-xl font-medium transition-all ${
                                    activeCategory === cat.id
                                        ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg'
                                        : 'bg-white text-slate-600 hover:bg-amber-50 border border-slate-200'
                                }`}
                            >
                                <cat.icon className="w-4 h-4" />
                                {cat.name}
                            </button>
                        ))}
                    </div>
                </div>
            </section>

            {/* FAQ List */}
            <section className="py-12">
                <div className="container-main">
                    <div className="max-w-3xl mx-auto space-y-4">
                        {filteredFaqs.length === 0 ? (
                            <div className="text-center py-12 bg-white rounded-2xl shadow">
                                <HelpCircle className="w-16 h-16 text-amber-300 mx-auto mb-4" />
                                <p className="text-slate-500 text-lg">Няма намерени въпроси</p>
                                <p className="text-slate-400">Опитайте с друго търсене или категория</p>
                            </div>
                        ) : (
                            filteredFaqs.map((faq) => (
                                <div 
                                    key={faq.id}
                                    className="bg-white rounded-2xl border border-amber-100 overflow-hidden shadow-sm hover:shadow-md transition-all"
                                >
                                    <button
                                        onClick={() => toggleItem(faq.id)}
                                        className="w-full flex items-center justify-between p-6 text-left"
                                    >
                                        <div className="flex items-start gap-4">
                                            <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${
                                                openItems[faq.id] 
                                                    ? 'bg-gradient-to-br from-amber-400 to-orange-500' 
                                                    : 'bg-amber-100'
                                            }`}>
                                                {(() => {
                                                    const cat = categories.find(c => c.id === faq.category);
                                                    const Icon = cat?.icon || HelpCircle;
                                                    return <Icon className={`w-5 h-5 ${openItems[faq.id] ? 'text-white' : 'text-amber-600'}`} />;
                                                })()}
                                            </div>
                                            <span className="font-semibold text-slate-800 pr-4">{faq.q}</span>
                                        </div>
                                        {openItems[faq.id] ? (
                                            <ChevronUp className="w-5 h-5 text-amber-500 flex-shrink-0" />
                                        ) : (
                                            <ChevronDown className="w-5 h-5 text-amber-500 flex-shrink-0" />
                                        )}
                                    </button>
                                    {openItems[faq.id] && (
                                        <div className="px-6 pb-6 text-slate-600 border-t border-amber-50 pt-4 ml-14">
                                            {faq.a}
                                        </div>
                                    )}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </section>

            {/* Still Need Help CTA */}
            <section className="py-16 bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 text-white">
                <div className="container-main text-center">
                    <h2 className="font-serif text-3xl md:text-4xl font-bold mb-4">Все още имате въпроси?</h2>
                    <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
                        Нашият екип е готов да ви помогне. Свържете се с нас!
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <a href="tel:0899972727">
                            <Button className="bg-white text-amber-700 hover:bg-amber-50 px-8 py-6 text-lg rounded-xl shadow-lg">
                                <Phone className="w-5 h-5 mr-2" />
                                0899 97 2727
                            </Button>
                        </a>
                        <Link to="/contact">
                            <Button className="bg-transparent border-2 border-white text-white hover:bg-white/10 px-8 py-6 text-lg rounded-xl">
                                Пишете ни
                            </Button>
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FAQPage;
